import { References } from '@/domain/impact-references/entities/references.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
};

export const getImpactReferences = createAppAsyncThunk(
  'impactReferences/getImpactReferences',
  async (
    params: Params,
    { extra: { impactReferencesGateway, snackbarGateway } },
  ): Promise<References> => {
    try {
      const references = await impactReferencesGateway.getReferences(
        params.projectId,
      );
      return references;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactReference.Message.error'));
}
